import script from "./DownloadFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadFiles.vue?vue&type=script&setup=true&lang=js"

import "./DownloadFiles.vue?vue&type=style&index=0&id=2d41c05f&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.32_webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d41c05f"]])

export default __exports__